import React from 'react'
import { Row, Col} from 'antd'
import IconCloud from '../../../assets/img/icon/icon-cloud.png'
import './card-bucket-count.scss'

export default ({bucketCount}) => (
    <div className="bucket-count-container">
        <Row type="flex" >
            <Col span={24}>
                <h2>Bucket Count</h2>
            </Col>
        </Row>
        <Row type="flex" align="middle">
            <Col span={20}>
                <h1>{bucketCount}</h1>
            </Col>
            <Col span={4}>
                <img src={IconCloud} alt='' className="icon" />
            </Col>
        </Row>
        <Row type="flex" gutter={10} align="middle">
            <Col span={12}>
                <div className="color-line"></div>
            </Col>
            <Col span={12}>

            </Col>
        </Row>

    </div>
)